import { useDataProvider, useRecordContext } from "react-admin";
import React, { FC, useEffect, useState } from "react";
import { isEmpty } from "lodash";
import get from "lodash/get";
import SparklingStarIcon from "../../../components/icons/SparklingStartIcon";

interface IWaveNameListField {
  record?: any;
  label: string;
}

const WaveNameListField: FC<IWaveNameListField> = ({ record = {} }) => {
  const recordContext = useRecordContext();
  const records = isEmpty(record) ? recordContext : record;

  const [busSchedule, setBusSchedule] = useState<IBusSchedule>();

  const provider = useDataProvider();
  const busScheduleId = get(records, "busScheduleId");
  const isCreatedByRouteOptimization = get(
    records,
    "isCreatedByRouteOptimization",
  );

  useEffect(() => {
    if (busScheduleId) {
      provider
        .getOne("busSchedules", { id: busScheduleId })
        .then(({ data: busSchedule }) => {
          setBusSchedule(busSchedule as IBusSchedule);
        });
    }
  }, [busScheduleId]);

  if (!busSchedule) {
    return <span>-</span>;
  }

  return (
    <span>
      {isCreatedByRouteOptimization && (
        <SparklingStarIcon
          style={{
            width: "24px",
            height: "24px",
            marginRight: "4px",
            verticalAlign: "middle",
            color: "#FFD700",
          }}
        />
      )}

      {busSchedule.name}
    </span>
  );
};

export default WaveNameListField;
